import { render, staticRenderFns } from "./ClientWpImport.vue?vue&type=template&id=0803dae3&scoped=true&"
import script from "./ClientWpImport.vue?vue&type=script&lang=js&"
export * from "./ClientWpImport.vue?vue&type=script&lang=js&"
import style0 from "./ClientWpImport.vue?vue&type=style&index=0&id=0803dae3&scoped=true&lang=css&"
import style1 from "./ClientWpImport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0803dae3",
  null
  
)

export default component.exports